import * as React from 'react';
import { Link } from 'gatsby';
import { IconChat, IconChevronLeft, IconChevronRight, IconEmail, IconRing } from '../icons/Icons';
import { useState } from 'react';
import Logo from '../../icons/SellUsYourJewelry';

const Submenu = ({ children, heading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openMenu = () => setIsOpen(true);
  const closeMenu = () => setIsOpen(false);
  return (
    <div>
      <button
        className="text-gray-700 hover:text-accentMd border-b-[1px] border-gray-100 py-3 indent-10 uppercase hover:tracking-wider duration-300 w-full text-left"
        onClick={openMenu}
      >
        {heading} &nbsp; <IconChevronRight />
      </button>
      <div className={'submenu' + (isOpen ? '' : ' hidden')}>
        <button
          onClick={closeMenu}
          className="text-left bg-accentMd hover:bg-accent text-xl font-bold indent-10 text-white py-3"
        >
          <IconChevronLeft className="translate-y-1 mx-3" />
          {heading}
        </button>
        {children}
      </div>
    </div>
  );
};

const HomeMenuDL = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleBurgerClick = e => {
    e.preventDefault();
    setIsOpen(i => !i);
  };
  return (
    <>
      <div className="fixed top-0 sm:static z-50 flex h-16 flex-row items-center w-full justify-between bg-white py-2 px-10 shadow-xl">
        <Link to={'/'} className={'logo'}>
          <Logo className={'w-[236px]'} />
        </Link>
        <div className="hidden justify-end md:block">
          <div className="flex flex-row space-x-10  ">
            <a href={'mailto:sell@grayandsons.com'}>
              <IconEmail />
              &ensp; E-mail
            </a>
            <a href={'tel:+13057706955'}>
              <IconRing />
              &ensp; Call
            </a>
            <Link to={'/chat-suyj/'}>
              <IconChat /> &ensp; Chat
            </Link>
          </div>
        </div>
        {/* THIS IS THE BURGER BUTTON */}
        <button
          aria-label={'Main Menu'}
          className="relative z-20 inline-block h-8 w-8 p-1 text-accent md:hidden"
          onClick={handleBurgerClick}
        >
          <svg fill="currentColor" viewBox="0 0 20 20" xmlns="https://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
      <nav>
        <div className={(isOpen ? '' : 'hidden ') + 'mobile-menu'}>
          <Link to="#">HOW IT WORKS</Link>
          <Submenu heading={'BRANDS WE BUY'}>
            <Link to="#">Rolex</Link>
            <Link to="#">Audemars Piguet</Link>
            <Link to="#">Patek Philippe</Link>
            <Link to="#">Tiffany & Co.</Link>
            <Link to="#">Van Cleef & Arpels</Link>
            <Link to="#">Cartier</Link>
            <Link to="#">See All Brands We Buy</Link>
          </Submenu>
          <Submenu heading={'FREE QUOTE'}>
            <Link to="#">Watch Quote</Link>
            <Link to="#">Jewelry Quote</Link>
            <Link to="#">Diamond Quote</Link>
            <Link to="#">Sterling Silver Quote</Link>
          </Submenu>
          <Submenu heading={'AREAS WE SERVE'}>
            <Link to="#">Surfside</Link>
            <Link to="#">Bay Harbor Islands</Link>
            <Link to="#">Fort Lauderdale (40min drive)</Link>
            <Link to="#">West Palm Beach</Link>
            <Link to="#">Miami (15min drive)</Link>
            <Link to="#">Aventura (20min drive)</Link>
            <Link to="#">Miami Beach (10 min drive)</Link>
            <Link to="#">Hollywood (20min drive)</Link>
            <Link to="#">Naples</Link>
            <Link to="#">Orlando</Link>
            <Link to="#">We serve the rest of the world</Link>
          </Submenu>
          <Link to="#">ABOUT US</Link>
          <Link to="#">CONTACT US</Link>
          <Link to="#">SHOP</Link>
        </div>
      </nav>
    </>
  );
};

export default HomeMenuDL;
